import api from '..'
import { CategoriesAPI } from './types'

const myCoursesCategories = ({ search = '' }) => {
  return api
    .get<CategoriesAPI>('/courses/categories', {
      params: {
        search: search,
      },
    })
    .then(({ data }) => data)
}

export default myCoursesCategories
